// extracted by mini-css-extract-plugin
export default {"rootWithEmptyMessage":"uzaoZn","link":"OpI344","root":"gyrz7H","ellipsis":"T_aNSy","item":"CWn4IW"};